export default __webpack_public_path__ + "static/media/mic_icon_bold.9c20ee7e.svg";